import {
    URLAPI,
    TYPE_MAINTENANCE_PATH,
    TYPE_MAINTENANCE_CREATE_PATH,
    TYPE_MAINTENANCE_UPDATE_PATH,
    TYPE_MAINTENANCE_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_type_maintenance: {
        data: [],

        status: 0,
        message: {},
    },

    _create_type_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _update_type_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_type_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_TYPE_MAINTENANCE = "GET_ALL_TYPE_MAINTENANCE";
export const CREATE_TYPE_MAINTENANCE = "CREATE_TYPE_MAINTENANCE";
export const UPDATE_TYPE_MAINTENANCE = "UPDATE_TYPE_MAINTENANCE";
export const DELETE_TYPE_MAINTENANCE = "DELETE_TYPE_MAINTENANCE";

export const type_maintenance_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_TYPE_MAINTENANCE:
            return {
                ...state,
                _get_all_type_maintenance: action.payload,
            };
        case CREATE_TYPE_MAINTENANCE:
            return {
                ...state,
                _create_type_maintenance: action.payload,
            };
        case UPDATE_TYPE_MAINTENANCE:
            return {
                ...state,
                _update_type_maintenance: action.payload,
            };
        case DELETE_TYPE_MAINTENANCE:
            return {
                ...state,
                _delete_type_maintenance: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllTypeMaintenance = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${TYPE_MAINTENANCE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_TYPE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_TYPE_MAINTENANCE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_TYPE_MAINTENANCE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createTypeMaintenance = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${TYPE_MAINTENANCE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_TYPE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_TYPE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_TYPE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateTypeMaintenance = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${TYPE_MAINTENANCE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_TYPE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_TYPE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_TYPE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteTypeMaintenance = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${TYPE_MAINTENANCE_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_TYPE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_TYPE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_TYPE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_type_maintenance = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
